import React from 'react';
import './scss/full-screen-loader.scss';
import Loader from './loader';

function FullScreenLoader(): React.ReactElement {
  return (
    <div className="full-screen-overlay text-center">
      <div style={{ position: 'fixed', top: '46%', left: '46%' }}>
        <Loader width="70px" imageNumber="0" />
      </div>
    </div>
  );
}

export default FullScreenLoader;
